import * as types from '../../../../lib/actionTypes.es6';

export function getPolicyCancellationRequestsAction(payload) {
  return {
    type: types.GET_POLICY_CANCELLATION_REQUESTS_REQUEST,
    payload: {
      ...payload,
      page: payload.page || 1,
      size: payload.size || 10,
    },
  };
}

export const getPolicyCancellationRequestsSuccess = (payload) => ({
  type: types.GET_POLICY_CANCELLATION_REQUESTS_SUCCESS,
  payload,
});

export const getPolicyCancellationRequestsFailure = (error) => ({
  type: types.GET_POLICY_CANCELLATION_REQUESTS_FAILURE,
  payload: error,
});

export function updatePolicyCancellationAction(payload) {
  return {
    type: types.UPDATE_POLICY_CANCELLATION_REQUEST,
    payload,
  };
}

export const updatePolicyCancellationSuccess = (payload) => ({
  type: types.UPDATE_POLICY_CANCELLATION_SUCCESS,
  payload,
});

export const updatePolicyCancellationFailure = (error) => ({
  type: types.UPDATE_POLICY_CANCELLATION_FAILURE,
  payload: error,
});

export const resetUpdatePolicyCancellationSuccess = () => ({
  type: types.RESET_UPDATE_POLICY_CANCELLATION_SUCCESS,
});

export const resetUpdatePolicyCancellationError = () => ({
  type: types.RESET_UPDATE_POLICY_CANCELLATION_ERROR,
});
